import React, { useCallback, useEffect } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { setServices } from './redux/features/services.feature';
import { useSelector, useDispatch } from 'react-redux';

// components
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute.component';
import Signin from './pages/signin';
import Signup from './pages/signup';
import ForgotPassword from './pages/forgot-password';
import Home from './pages/index';
import JobListings from './pages/JobListings';
import JobDetail from './pages/JobDetail';
import UserProfile from './pages/profile/UserProfile';
import EditUserProfile from './pages/profile/EditUserProfile';
import MyJobs from './pages/my-jobs';
import Notifications from './pages/notifications';
import CreateJob from './pages/create-job';
import BidsList from './pages/BidsList';
import UnAuthRoute from './components/UnAuthRoute.component';
import UserChat from './pages/UserChat';
import Payments from './pages/Payments';

// stylesheet
import './App.css';
import EditJob from './pages/EditJob.component';
import Blogs from './pages/Blogs';
import BlogPost from './pages/BlogPost';

function App() {
  
  const dispatch = useDispatch();

  const isLogin = useSelector(state => state.auth.isLogin);
  const token  = useSelector(state => state.auth.token);

  const getServices = useCallback(async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/services`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
    .then(r => r.json())
    .then(response => {
      if(response.success){
        dispatch(setServices(response.records.data));
      }
    })
  }, []);
  
  useEffect(() => {
    if(isLogin){
      getServices();
    }
  }, []);

  return (
    <React.Fragment>
      
       <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signin" element={<UnAuthRoute><Signin /></UnAuthRoute>} />
        <Route path="/verifying/:id" element={<UnAuthRoute><Signin /></UnAuthRoute>} />
        <Route path="/signup" element={<UnAuthRoute><Signup /></UnAuthRoute>} />
        <Route path="/forgot-password" element={<UnAuthRoute><ForgotPassword /></UnAuthRoute>} />
        
       
        <Route path="/jobs" element={<ProtectedRoute><JobListings /></ProtectedRoute>} />
        <Route path="/jobs/:id" element={<ProtectedRoute><JobDetail /></ProtectedRoute>} />
        <Route path="/edit-jobs/:id" element={<ProtectedRoute><EditJob /></ProtectedRoute>} />
        
        
        <Route path="/profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
        <Route path="/profile/:id" element={<ProtectedRoute><EditUserProfile /></ProtectedRoute>} />
        <Route path="/my-jobs" element={<ProtectedRoute><MyJobs /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
        <Route path="/create-job" element={<ProtectedRoute><CreateJob /></ProtectedRoute>} />
        <Route path="/bids" element={<ProtectedRoute><BidsList /></ProtectedRoute>} />        
        <Route path="/chat" element={<ProtectedRoute><UserChat /></ProtectedRoute>} />        
        <Route path="/payment" element={<ProtectedRoute><Payments /></ProtectedRoute>} />        
        
        <Route path="/blogs" element={<Blogs />} />        
        <Route path="/blogs/:slug" element={<BlogPost />} />        

      </Routes> 


    </React.Fragment>
  );
}

export default App;
